/* 列傳的時局：借用圖解三國的州郡勢力圖，標出每一章打在哪裡、當時天下是什麼局面
 * 地點：圖解三國已有的地名直接用；沒有的照經緯度換算（用已知地名擬合一個仿射變換，誤差在幾個像素內）。 */
// @ts-nocheck
import { SG } from '../core/sg.ts';
import { FAC, PROV, GEO, E, states, DEFS } from '../pages/tujie-data.ts';
import BG from './bg/index.ts';

// 經緯度（今地，約略）：前半是圖解三國已有的地名（拿來擬合），後半是列傳要用、圖上沒有的
const LL = {
  洛陽: [112.45, 34.62], 長安: [108.94, 34.27], 許: [113.85, 34.03], 鄴: [114.35, 36.33], 成都: [104.07, 30.67], 建業: [118.78, 32.05],
  襄陽: [112.14, 32.04], 江陵: [112.19, 30.35], 合肥: [117.27, 31.86], 壽春: [116.78, 32.57], 下邳: [117.95, 34.32], 濮陽: [115.03, 35.76],
  潼關: [110.24, 34.54], 夷陵: [111.29, 30.7], 定軍山: [106.67, 33.1], 官渡: [114.0, 34.73], 長坂: [111.75, 30.8], 鉅鹿: [115.0, 37.2],
  // 圖上沒有的
  宛: [112.53, 33.0], 西華: [114.53, 33.78], 梁: [112.85, 34.17], 牛渚: [118.5, 31.55], 宣城: [118.75, 30.95], 丹徒: [119.45, 32.2],
  夏口: [114.27, 30.57], 柴桑: [115.97, 29.7], 濡須: [117.9, 31.6], 中牟: [113.97, 34.72], 濟北: [116.5, 36.2], 安喜: [115.0, 38.5],
  北海: [118.9, 36.7], 隆中: [112.05, 32.0], 漢水: [106.75, 33.2], 平陽: [111.52, 36.08], 蒲阪: [110.33, 34.83], 冀: [105.25, 34.73],
  江州: [106.55, 29.56], 宕渠: [106.97, 31.0], 博望: [112.8, 33.15], 桂陽: [113.0, 25.8], 公安: [112.23, 30.06], 箕谷: [106.9, 33.6],
  東海: [118.35, 34.6], 長離: [105.4, 35.1], 枹罕: [103.2, 35.6], 新城: [110.7, 32.0], 襄平: [123.17, 41.27], 歷陽: [118.35, 31.7],
  巴丘: [113.1, 29.37], 皖: [116.6, 30.5], 益陽: [112.35, 28.55], 丹楊: [118.9, 31.2], 宜都: [111.4, 30.4], 石亭: [116.9, 30.8],
  涇縣: [118.4, 30.7], 海昏: [115.8, 29.1],
};
// 用圖上已有、也有經緯度的地名，最小平方擬合 x = a·lon + b·lat + c（y 同理）
const fit = (() => {
  const pts = Object.keys(LL).filter((n) => GEO.places[n]);
  const solve = (k) => {
    let S = [[0, 0, 0], [0, 0, 0], [0, 0, 0]], r = [0, 0, 0];
    for (const n of pts) { const v = [LL[n][0], LL[n][1], 1], t = GEO.places[n][k]; for (let i = 0; i < 3; i++) { r[i] += v[i] * t; for (let j = 0; j < 3; j++) S[i][j] += v[i] * v[j]; } }
    for (let i = 0; i < 3; i++) for (let j = i + 1; j < 3; j++) { const f = S[j][i] / S[i][i]; for (let q = 0; q < 3; q++) S[j][q] -= f * S[i][q]; r[j] -= f * r[i]; }
    const x = [0, 0, 0];
    for (let i = 2; i >= 0; i--) { let s = r[i]; for (let j = i + 1; j < 3; j++) s -= S[i][j] * x[j]; x[i] = s / S[i][i]; }
    return x;
  };
  return [solve(0), solve(1)];
})();
const at = (name) => {
  if (GEO.places[name]) return GEO.places[name];
  const ll = LL[name];
  if (!ll) return null;
  return fit.map((c) => +(c[0] * ll[0] + c[1] * ll[1] + c[2]).toFixed(1));
};

// 每章（列傳選單上的那一章；分幕的後一幕沒登記就用第一幕的）：[地點, 年份, 指定的圖解三國事件（自動挑得不對時才填）]
const AT = {
  'sunjian-1': ['西華', 184], 'sunwu-2': ['宛', 184], 'sunwu-13': ['赤壁', 208], 'zhouyu-3b': ['江陵', 208], 'machao-2': ['潼關', 211], 'machao-3': ['潼關', 211], 'sunwu-3': ['梁', 191], 'sunwu-4': ['陽人', 191], 'sunwu-5': ['牛渚', 195], 'sunwu-6': ['神亭', 195], 'sunwu-7': ['神亭', 197],
  'sunwu-8': ['宣城', 196], 'sunwu-9': ['丹徒', 200], 'sunwu-10': ['夏口', 208], 'sunwu-11': ['柴桑', 208], 'sunwu-12': ['赤壁', 208], 'sunwu-14': ['赤壁', 208],
  'sunwu-15': ['合肥', 215], 'sunwu-16': ['濡須', 213, '赤壁之戰'], 'sunwu-17': ['江陵', 219], 'sunwu-18': ['夷陵', 222],
  'caocao-1': ['中牟', 189], 'caocao-2': ['汴水', 190], 'caocao-3': ['濟北', 192], 'caocao-4': ['濮陽', 194], 'caocao-4a': ['濮陽', 194], 'caocao-5': ['宛', 197], 'caocao-6': ['下邳', 198],
  'caocao-7': ['白馬', 200], 'caocao-8': ['烏巢', 200], 'caocao-9': ['白狼山', 207], 'caocao-10': ['赤壁', 208], 'caocao-11': ['潼關', 211], 'caocao-12': ['定軍山', 219],
  'liubei-1': ['安喜', 185], 'liubei-2': ['北海', 193], 'liubei-3': ['下邳', 196], 'liubei-4': ['白馬', 200], 'liubei-5': ['隆中', 207], 'liubei-6': ['長坂', 208],
  'liubei-7': ['赤壁', 208], 'liubei-8': ['雒城', 214], 'liubei-9': ['定軍山', 219], 'liubei-10': ['漢水', 219], 'liubei-11': ['夷陵', 222],
  'guanzhang-1': ['江州', 214], 'guanzhang-2': ['宕渠', 215], 'guanzhang-3': ['江陵', 217], 'guanzhang-4': ['樊城', 219], 'guanzhang-5': ['麥城', 219],
  'zhaoyun-1': ['博望', 202], 'zhaoyun-2': ['桂陽', 209], 'zhaoyun-3': ['公安', 211, '赤壁之戰'], 'zhaoyun-4': ['箕谷', 228],
  'machao-1': ['平陽', 202], 'machao-2a': ['蒲阪', 211], 'machao-3a': ['潼關', 211], 'machao-4': ['潼關', 211], 'machao-5a': ['冀', 212, '潼關之戰'], 'machao-6': ['成都', 214],
  'xiahouyuan-1': ['官渡', 200], 'xiahouyuan-2': ['東海', 206], 'xiahouyuan-3': ['祁山', 214, '潼關之戰'], 'xiahouyuan-4': ['長離', 214, '潼關之戰'], 'xiahouyuan-5': ['枹罕', 214, '潼關之戰'],
  'simayi-1': ['新城', 228], 'simayi-2': ['五丈原', 234], 'simayi-3': ['襄平', 238], 'simayi-4': ['高平陵', 249],
  'zhouyu-1': ['歷陽', 195], 'zhouyu-2': ['赤壁', 208], 'zhouyu-3': ['夷陵', 208], 'zhouyu-4': ['巴丘', 210],
  'ganning-1': ['夏口', 203], 'ganning-2': ['夷陵', 208], 'ganning-3': ['皖', 214, '赤壁之戰'], 'ganning-4': ['益陽', 215],
  'luxun-1': ['丹楊', 217, '逍遙津之戰'], 'luxun-2': ['宜都', 219], 'luxun-3': ['石亭', 228, '夷陵之戰'], 'luxun-4': ['襄陽', 234],
  'taishici-1': ['洛陽', 186], 'taishici-2': ['涇縣', 195], 'taishici-3': ['丹楊', 197], 'taishici-4': ['海昏', 199],
};
// 年份所在的圖解三國事件：該年在事件期間（同地點優先），否則取最近一個已發生的事件（當時的勢力分布）
const span = (e) => { const m = e.y.match(/\d+/g).map(Number); return [m[0], m[m.length - 1]]; };
function eventAt(year, place, title) {
  if (title) { const i = E.findIndex((e) => e.t === title), [a, b] = span(E[i]); return { i, during: year >= a && year <= b }; }
  const inside = E.map((e, i) => i).filter((i) => { const [a, b] = span(E[i]); return year >= a && year <= b; });
  const exact = inside.find((i) => (E[i].p || []).includes(place));
  if (exact != null) return { i: exact, during: true };
  if (inside.length) return { i: inside[inside.length - 1], during: true };
  let best = -1;
  E.forEach((e, i) => { if (span(e)[0] <= year) best = i; });
  return { i: Math.max(0, best), during: false };
}

// 州郡路徑放進頁面一次（id 改成 tj-*，免得和別的 SVG 撞名）
function ensureDefs() {
  if (document.getElementById('tj-defs')) return;
  document.body.insertAdjacentHTML('beforeend', `<svg width="0" height="0" style="position:absolute" aria-hidden="true"><defs id="tj-defs">${DEFS.replace(/id="g-/g, 'id="tj-')}</defs></svg>`);
}
function fill(list) {
  if (list.length === 1) return FAC[list[0]].c;
  const id = 'tj-pt-' + list.join('-');
  if (!document.getElementById(id)) {
    const w = 9, rects = list.map((f, i) => `<rect x="${i * w}" y="0" width="${w}" height="${w * list.length}" fill="${FAC[f].c}"/>`).join('');
    document.getElementById('tj-defs').insertAdjacentHTML('beforeend', `<pattern id="${id}" patternUnits="userSpaceOnUse" width="${w * list.length}" height="${w * list.length}" patternTransform="rotate(45)">${rects}</pattern>`);
  }
  return `url(#${id})`;
}
// 勢力圖：ev = 圖解三國事件序號（取那時的州郡歸屬），marks = [{x, y, label, n, hot}]，視窗框住所有標記
function mapSVG(ev, marks, minW = 260, scale = 26) {
  ensureDefs();
  const st = states[ev];
  let x0 = Math.min(...marks.map((k) => k.x)), x1 = Math.max(...marks.map((k) => k.x)), y0 = Math.min(...marks.map((k) => k.y)), y1 = Math.max(...marks.map((k) => k.y));
  let w = Math.max(minW, (x1 - x0) * 1.35 + 80), h = w * 0.8;
  if ((y1 - y0) * 1.3 + 70 > h) { h = (y1 - y0) * 1.3 + 70; w = h / 0.8; }
  const vx = Math.min(GEO.W - w, Math.max(0, (x0 + x1) / 2 - w / 2)), vy = Math.min(GEO.H - h, Math.max(0, (y0 + y1) / 2 - h / 2));
  const fs = w / scale; // 字級跟著視窗縮放，畫面上看起來差不多大
  let s = `<svg class="tj-map" viewBox="${vx.toFixed(1)} ${vy.toFixed(1)} ${w.toFixed(1)} ${h.toFixed(1)}" role="img" aria-label="${esc(E[ev].t)}時的州郡勢力"><use href="#tj-land" class="tj-land"/>`;
  for (const p of PROV) s += `<use href="#tj-${p.id}" fill="${fill(st[p.id])}" class="tj-pv"><title>${p.n}：${st[p.id].map((f) => FAC[f].n).join('、')}</title></use>`;
  for (const r of GEO.rivers) s += `<use href="#tj-r-${r.n}" class="tj-rv"/>`;
  for (const p of PROV) { const [x, y] = GEO.labels[p.id]; if (x > vx && x < vx + w && y > vy && y < vy + h) s += `<text class="tj-pl" x="${x}" y="${y}" font-size="${(fs * 0.9).toFixed(1)}">${p.n}</text>`; }
  const r = fs * 0.42;
  const shown = [];
  for (const k of marks) {
    s += `<circle class="tj-mk${k.hot ? ' hot' : ''}" cx="${k.x}" cy="${k.y}" r="${(k.hot ? r * 1.3 : r).toFixed(1)}" stroke-width="${(fs / 9).toFixed(2)}"/>`;
    if (k.n != null) s += `<text class="tj-n" x="${k.x}" y="${k.y + r * 0.45}" font-size="${(r * 1.25).toFixed(1)}">${k.n}</text>`;
    if (k.label && !shown.some((o) => Math.abs(o.x - k.x) < fs * 3 && Math.abs(o.y - k.y) < fs * 1.2)) shown.push(k); else continue; // 太近的地名只標第一個
    s += `<text class="tj-ml" x="${k.x + r * 1.7}" y="${k.y + fs * 0.35}" font-size="${fs.toFixed(1)}" stroke-width="${(fs / 5).toFixed(2)}">${esc(k.label)}</text>`;
  }
  return s + '</svg>';
}
const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
function legend(ev) {
  const seen = [];
  for (const p of PROV) for (const f of states[ev][p.id]) if (!seen.includes(f)) seen.push(f);
  return `<div class="tj-lg">${seen.map((f) => `<span><i style="background:${FAC[f].c}"></i>${FAC[f].n}</span>`).join('')}</div>`;
}

SG.TUJIE = {
  place(id) {
    const d = SG.CAMPAIGN && SG.CAMPAIGN.chapters[id], a = AT[id] || (d && d.of && AT[d.of]); // 分幕的後一幕沒有另外登記就用第一幕的
    return a && { name: a[0], year: a[1], ev: a[2], xy: at(a[0]) };
  },
  has(id) { const d = SG.CAMPAIGN.chapters[id]; return !!(BG[id] || (d && d.of && BG[d.of])); },
  // 一章的圖解：地圖（標出這一章、當時的州郡勢力）＋這一章的交戰雙方、前情、結果與影響；圖解三國的大事件只留連結
  chapterHTML(id) {
    const d = SG.CAMPAIGN.chapters[id], g = BG[id] || (d && d.of && BG[d.of]), a = this.place(id);
    if (!a || !a.xy) return '';
    const { i } = eventAt(a.year, a.name, a.ev), e = E[i];
    const sides = g && g.sides ? `<div class="tj-sides">${g.sides.map((s) => `<div><b><i style="background:${(FAC[s.f] || FAC.han).c}"></i>${esc(s.n)}${s.w ? '<em>勝</em>' : ''}</b><span>${esc(s.l)}</span></div>`).join('')}</div>` : '';
    const rows = g ? [['前情', g.before], ['結果與影響', g.after]].filter((r) => r[1]).map(([k, v]) => `<dt>${k}</dt><dd>${esc(v)}</dd>`).join('') : '';
    return `<div class="tj-ctx">${mapSVG(i, [{ x: a.xy[0], y: a.xy[1], label: a.name, hot: true }])}${legend(i)}
      <div class="tj-ev">${sides}${rows ? `<dl>${rows}</dl>` : ''}${g && g.src ? `<p class="tj-src">${esc(g.src)}</p>` : ''}
      <a class="tj-link" href="history.html#e${i + 1}" target="_blank" rel="noopener">圖解三國：${esc(e.t)}（${esc(e.y)}）↗</a></div></div>`;
  },
};
